export default "__VITE_ASSET__BE1_b7VQ__"